module.exports = __webpack_public_path__ + "media/images/meta/rowhouse/favicon-176b8f3a655a193353466e43758ba102.png";